import React from "react";
import { Grid } from "sprint-common-web";

import { OnPremAssetDetailsPageHeader } from "./header/OnPremAssetDetailsPageHeader";
import { OnPremAssetDetailsSections } from "./OnPremAssetDetailsSections";

export const OnPremAssetDetailsPage: React.FunctionComponent = () => {
    return (
        <Grid>
            <OnPremAssetDetailsPageHeader />
            <OnPremAssetDetailsSections />
        </Grid>
    );
};
